/*
Akhila 11/19/2022 2700271704 Created new Component
*/
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import TriggerAccountSubTabs from './SubTabs';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function EventTacticTabs({value}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.subContent}>
        {value === 0 && (
          <TriggerAccountSubTabs/>
        )}
      </div>
    </div>
  );
}
